/**
 * 订单状态
 * @description 根据状态显示不同的颜色
 */

import { SwapOrderStatus } from '@/constants';
import {
  CheckCircleIcon,
  CirclepromptIcon,
  LoadingIcon,
} from '@bfe/moly-icons';

export default function OrderStatus({ status }: { status: SwapOrderStatus }) {
  const statusLabel = {
    [SwapOrderStatus.processing]: '进行中',
    [SwapOrderStatus.success]: '成功',
    [SwapOrderStatus.fail]: '失败',
    [SwapOrderStatus.rollback]: '取消',
  };
  return (
    <div className="flex items-center gap-1.5">
      {status === SwapOrderStatus.processing && (
        <LoadingIcon className="text-[#9747ff] animate-spin size-4" />
      )}
      {status === SwapOrderStatus.success && (
        <CheckCircleIcon className="text-bds-green-700-normal size-4" />
      )}
      {[SwapOrderStatus.fail, SwapOrderStatus.rollback].includes(status) && (
        <CirclepromptIcon className="text-bds-red-700-normal size-4" />
      )}
      <p className="text-sm">{statusLabel[status] ?? '--'}</p>
    </div>
  );
}
